// extracted by mini-css-extract-plugin
export default {"root":"classes_root__YNzkg","icon":"classes_icon__mOEzr","content":"classes_content__fT5Xe"};